module.exports = function taneja(a, b) {
    var ii = a.length,
        ans = 0;
    for (var i = 0; i < ii ; i++) {
        ans += (a[i] + b[i]) / 2 * Math.log((a[i] + b[i]) / (2 * Math.sqrt(a[i] * b[i])));
    }
    return ans;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/distances/taneja.js
 ** module id = 68
 ** module chunks = 0
 **/